import React, { forwardRef } from "react";
import Icon from "../AppIcon";

const Textarea = forwardRef(({ className = "", onChange, rows = 3, label, id, error, required, ...props }, ref) => {
    // Handle onChange to pass the full event object to parent
    const handleChange = (e) => {
        if (onChange) {
            onChange(e);
        }
    };

    const baseClass = error 
        ? "flex w-full rounded-md border border-red-500 bg-background px-3 py-2 text-base ring-offset-background placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-red-500 focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 md:text-sm"
        : "flex w-full rounded-md border border-input bg-background px-3 py-2 text-base ring-offset-background placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 md:text-sm";

    // Function to render the textarea element
    const renderTextarea = () => (
        <textarea
            className={baseClass + " " + className}
            rows={rows}
            id={id}
            ref={ref}
            onChange={handleChange}
            {...props}
        />
    );

    // If label is provided, render with label, otherwise just the textarea
    if (label) {
        return (
            <div className="space-y-2">
                <label 
                    htmlFor={id} 
                    className="block text-sm font-medium text-gray-700"
                >
                    {label}
                    {required && <span className="text-red-500 ml-1">*</span>}
                </label>
                {renderTextarea()}
                {error && (
                    <p className="text-sm text-red-600 flex items-center gap-1">
                        <Icon name="AlertCircle" size={14} />
                        {error}
                    </p>
                )}
            </div>
        );
    }

    // Just render the textarea without a label
    return renderTextarea();
});

Textarea.displayName = "Textarea";

export default Textarea;
